<template>
  <div class="private-config-container">
    <div
      class="customer-list-box"
      :class="expandedArrow ? '' : 'openTree'">
      <div
        class="customer-list-box-tree"
        v-show="expandedArrow">
        <p class="title">客户列表</p>
        <el-button
          v-show="expandedArrow"
          type="primary"
          class="primary-btn primary-ang-btn"
          size="small"
          @click="openCreateDialog"
          ><i class="el-icon-plus"></i>新增客户</el-button
        >
        <ul class="list-box">
          <li
            v-for="(item, index) in customerList"
            :key="index"
            :class="`text-overflow ${
              selectCustomerInfo.id === item.id ? 'active' : ''
            }`"
            :title="item.companyName"
            @click="onUserClick(item)">
            {{ item.companyName }}
          </li>
        </ul>
      </div>
      <div
        class="expaned"
        @click="() => (expandedArrow = !expandedArrow)">
        <i
          v-if="!expandedArrow"
          size="14"
          class="el-icon-arrow-right el-icon"></i>
        <i
          v-else
          size="14"
          class="el-icon-arrow-left el-icon"></i>
      </div>
    </div>
    <div
      class="customer-box outer-page-primary"
      :style="{ width: expandedArrow ? 'calc(100% - 276px)' : '100%' }">
      <div class="justify-flex">
        <el-tabs
          class="tab-page-primary"
          v-model="activeTab"
          @tab-click="tabsClick">
          <el-tab-pane
            label="客户部署权限"
            name="1">
          </el-tab-pane>
          <el-tab-pane
            label="客户信息"
            name="2">
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="opera-cell">
        <div
          class="operation-btns common-button-box"
          v-if="configVisible">
          <el-button
            size="small"
            type="primary"
            class="primary-btn"
            @click="saveConfig"
            >保存当前信息</el-button
          >
          <el-button
            size="small"
            class="negative-btn normal-btn"
            :disabled="!customerList.length"
            @click="downloadLicense"
            >生成License文件</el-button
          >
          <el-button
            size="small"
            class="negative-btn normal-btn gr9"
            @click="reset('config')"
            >重置</el-button
          >
        </div>
        <el-button
          size="small"
          class="negative-btn normal-btn"
          :disabled="!customerList.length"
          @click="openDeleteDialog"
          >删除当前客户</el-button
        >
        <div class="import-tips public-tips-primary">
          (注意：对于所有数量，设置为“-1”代表不做限制)
        </div>
      </div>
      <div
        v-if="activeTab === '1'"
        class="customer-config-box">
        <div class="config-item-box">
          <div class="title">
            <div class="icon">
              <img
                src="@/assets/icon/projectLimit.png"
                alt="" />
            </div>
            <span class="text searchLabel">全局限制</span>
          </div>
          <div class="content">
            <div class="project-config globalLimit">
              <div class="config-item">
                <span
                  class="label searchLabel"
                  style="width: 112px"
                  >单项目数量(个)：</span
                >
                <el-input-number
                  class="input-number-primary"
                  controls-position="right"
                  size="mini"
                  v-model="projects.projectCountLimit"
                  :min="-1"></el-input-number>
              </div>
              <div class="config-item">
                <span
                  class="label searchLabel"
                  style="width: 128px"
                  >集群项目数量(个)：</span
                >
                <el-input-number
                  class="input-number-primary"
                  controls-position="right"
                  size="mini"
                  v-model="projects.clusterCountLimit"
                  :min="-1"></el-input-number>
              </div>
              <div class="config-item">
                <span
                  class="label searchLabel"
                  style="width: 122px"
                  >场景数量(个)：</span
                >
                <el-input-number
                  class="input-number-primary"
                  controls-position="right"
                  size="mini"
                  v-model="projects.sceneCountLimit"
                  :min="-1"></el-input-number>
              </div>
            </div>
            <div class="project-config globalLimit">
              <div class="config-item">
                <span class="label searchLabel">文件总大小(GB)：</span>
                <el-input-number
                  class="input-number-primary"
                  controls-position="right"
                  size="mini"
                  v-model="projects.totalFileSizeLimit"
                  :min="-1"></el-input-number>
              </div>
              <div class="config-item">
                <span class="label searchLabel">单个文件大小(MB)：</span>
                <el-input-number
                  class="input-number-primary"
                  controls-position="right"
                  size="mini"
                  v-model="warranty.globalFileUploadSizeLimit"
                  :min="-1"></el-input-number>
              </div>
              <div class="config-item">
                <span
                  class="label searchLabel"
                  style="width: 122px"
                  >数据集数量(个)：</span
                >
                <el-input-number
                  class="input-number-primary"
                  controls-position="right"
                  size="mini"
                  v-model="projects.dataSetCountLimit"
                  :min="-1"></el-input-number>
              </div>
            </div>
            <div class="project-config globalLimit">
              <div class="config-item">
                <span
                  class="label searchLabel"
                  style="width: 112px"
                  >文件数量(个)：</span
                >
                <el-input-number
                  class="input-number-primary"
                  controls-position="right"
                  size="mini"
                  v-model="projects.fileCountLimit"
                  :min="-1"></el-input-number>
              </div>
              <div class="config-item">
                <span
                  class="label searchLabel"
                  style="width: 128px"
                  >转换节点数量(个)：</span
                >
                <el-input-number
                  class="input-number-primary"
                  controls-position="right"
                  size="mini"
                  v-model="projects.convertNodesCountLimit"
                  :min="-1"></el-input-number>
              </div>
              <div class="config-item">
                <span class="label searchLabel">发布节点数量(个)：</span>
                <el-input-number
                  class="input-number-primary"
                  controls-position="right"
                  size="mini"
                  v-model="projects.resNodesCountLimit"
                  :min="-1"></el-input-number>
              </div>
            </div>
          </div>
        </div>
        <div class="config-item-box">
          <div class="title">
            <div class="icon">
              <img
                src="@/assets/icon/useLimit.png"
                alt="" />
            </div>
            <span class="text searchLabel">单项目限制</span>
          </div>
          <div class="content">
            <div class="single-config globalLimit">
              <div class="config-item">
                <span
                  class="label searchLabel"
                  style="width: 111px"
                  >文件数量(个)：</span
                >
                <el-input-number
                  class="input-number-primary"
                  controls-position="right"
                  size="mini"
                  v-model="projects.fileCountPerProjectLimit"
                  :min="-1"></el-input-number>
              </div>
              <div class="config-item">
                <span
                  class="label searchLabel"
                  style="width: 129px"
                  >数据集数量(个)：</span
                >
                <el-input-number
                  class="input-number-primary"
                  controls-position="right"
                  size="mini"
                  v-model="projects.dataSetCountPerProjectLimit"
                  :min="-1"></el-input-number>
              </div>
              <div class="config-item">
                <span
                  class="label searchLabel"
                  style="width: 122px"
                  >场景数量(个)：</span
                >
                <el-input-number
                  class="input-number-primary"
                  controls-position="right"
                  size="mini"
                  v-model="projects.sceneCountPerProjectLimit"
                  :min="-1"></el-input-number>
              </div>
            </div>
          </div>
        </div>
        <div class="config-item-box">
          <div class="title">
            <div class="icon">
              <img
                src="@/assets/icon/datasetLimit.png"
                alt="" />
            </div>
            <span class="text searchLabel">单项目数据集类型</span>
          </div>
          <div class="common-bussiness-collapse-box">
            <el-collapse
              accordion
              v-model="activeTypes">
              <el-collapse-item name="bim">
                <template slot="title">
                  <div>
                    <i
                      :class="`collapse__arrow el-icon-arrow-down ${
                        activeTypes.includes('bim') ? 'is-active' : ''
                      }`"></i>
                    <span class="searchLabel">BIM模型</span>
                  </div>
                  <div @click="e => e.stopPropagation()">
                    <span class="searchLabel">是否启用：</span>
                    <el-switch
                      class="switch-primary"
                      @change="value => handleSwitchChange('bim', value)"
                      v-model="dataSets.bim.enable"
                      active-color="#077ffe"
                      inactive-color="#b7b7b7">
                    </el-switch>
                  </div>
                </template>
                <div class="dataset-config">
                  <div class="count-config">
                    <div class="label searchLabel">数据集数量(个)：</div>
                    <el-input-number
                      class="input-number-primary"
                      controls-position="right"
                      size="mini"
                      @change="value => handleInputChange('bim', value)"
                      v-model="dataSets.bim.dataSetLimit"
                      :min="-1" />
                  </div>
                  <div
                    class="common-checkbox-box dataset-config-dataSetCount checkbox-gap">
                    <el-checkbox
                      class="checkbox-primary dataSet-menu"
                      v-for="(item, index) in bimMenu"
                      :key="index"
                      :value="isDataSetMenuChecked('bim', item)"
                      @change="
                        value => handleDataSetMenuChange('bim', item, value)
                      "
                      >{{ item.name }}</el-checkbox
                    >
                  </div>
                </div>
                <div class="dataset-config">
                  <div
                    class="label searchLabel"
                    style="margin-left: 38px">
                    数据来源：
                  </div>
                  <el-checkbox
                    class="select-all checkbox-primary"
                    :indeterminate="bimSourceIndeterminate"
                    :value="bimSourceSelectAll"
                    @change="
                      value => handleSelectAllChange('bim', 'source', value)
                    "
                    >全选</el-checkbox
                  >
                  <div
                    class="checkbox-primary-content checkbox-gap"
                    style="margin-left: 74px">
                    <el-checkbox
                      class="checkbox-primary checkbox-source"
                      v-for="(item, index) in bimSourceList"
                      :key="index"
                      :value="isConfigChecked('bim', 'source', item)"
                      @change="
                        value =>
                          handleDataConfigCheckChange(
                            'bim',
                            'source',
                            item,
                            value
                          )
                      "
                      >{{ item.typeName }}</el-checkbox
                    >
                  </div>
                </div>
                <div class="dataset-config">
                  <div
                    class="label searchLabel"
                    style="margin-left: 38px">
                    文件类型：
                  </div>
                  <el-checkbox
                    class="select-all checkbox-primary"
                    :indeterminate="bimExtensionIndeterminate"
                    :value="bimExtensionSelectAll"
                    @change="
                      value => handleSelectAllChange('bim', 'extension', value)
                    "
                    >全选</el-checkbox
                  >
                  <div
                    class="checkbox-gap"
                    style="margin-left: 113px">
                    <el-checkbox
                      class="checkbox-primary checkbox-source"
                      v-for="(item, index) in bimExtensionList"
                      :key="index"
                      :value="isConfigChecked('bim', 'extension', item)"
                      @change="
                        value =>
                          handleDataConfigCheckChange(
                            'bim',
                            'extension',
                            item,
                            value
                          )
                      "
                      >{{ item.extension }}</el-checkbox
                    >
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item name="rs">
                <template slot="title">
                  <div>
                    <i
                      :class="`collapse__arrow el-icon-arrow-down ${
                        activeTypes.includes('rs') ? 'is-active' : ''
                      }`"></i>
                    <span class="searchLabel">遥感数据</span>
                  </div>
                  <div @click="e => e.stopPropagation()">
                    <span class="searchLabel">是否启用：</span>
                    <el-switch
                      class="switch-primary"
                      @change="value => handleSwitchChange('rs', value)"
                      v-model="dataSets.rs.enable"
                      active-color="#077ffe"
                      inactive-color="#b7b7b7">
                    </el-switch>
                  </div>
                </template>
                <div class="dataset-config">
                  <div class="count-config">
                    <div class="label searchLabel">数据集数量(个)：</div>
                    <el-input-number
                      class="input-number-primary"
                      controls-position="right"
                      size="mini"
                      @change="value => handleInputChange('rs', value)"
                      v-model="dataSets.rs.dataSetLimit"
                      :min="-1" />
                  </div>
                  <div class="common-checkbox-box checkbox-gap">
                    <el-checkbox
                      class="checkbox-primary checkbox-source"
                      v-for="(item, index) in rsMenu"
                      :key="index"
                      :value="isDataSetMenuChecked('rs', item)"
                      @change="
                        value => handleDataSetMenuChange('rs', item, value)
                      "
                      >{{ item.name }}</el-checkbox
                    >
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item name="wmts">
                <template slot="title">
                  <div>
                    <i
                      :class="`collapse__arrow el-icon-arrow-down ${
                        activeTypes.includes('wmts') ? 'is-active' : ''
                      }`"></i>
                    <span class="searchLabel">WMTS地图服务</span>
                  </div>
                  <div @click="e => e.stopPropagation()">
                    <span class="searchLabel">是否启用：</span>
                    <el-switch
                      class="switch-primary"
                      @change="value => handleSwitchChange('wmts', value)"
                      v-model="dataSets.wmts.enable"
                      active-color="#077ffe"
                      inactive-color="#b7b7b7">
                    </el-switch>
                  </div>
                </template>
                <div class="dataset-config">
                  <div class="count-config">
                    <div class="label searchLabel">数据集数量(个)：</div>
                    <el-input-number
                      class="input-number-primary"
                      controls-position="right"
                      size="mini"
                      @change="value => handleInputChange('wmts', value)"
                      v-model="dataSets.wmts.dataSetLimit"
                      :min="-1" />
                  </div>
                  <div class="common-checkbox-box checkbox-gap">
                    <el-checkbox
                      class="checkbox-primary checkbox-source"
                      v-for="(item, index) in wmtsMenu"
                      :key="index"
                      :value="isDataSetMenuChecked('wmts', item)"
                      @change="
                        value => handleDataSetMenuChange('wmts', item, value)
                      "
                      >{{ item.name }}</el-checkbox
                    >
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item name="osgb">
                <template slot="title">
                  <div>
                    <i
                      :class="`collapse__arrow el-icon-arrow-down ${
                        activeTypes.includes('osgb') ? 'is-active' : ''
                      }`"></i>
                    <span class="searchLabel">倾斜摄影</span>
                  </div>
                  <div @click="e => e.stopPropagation()">
                    <span class="searchLabel">是否启用：</span>
                    <el-switch
                      class="switch-primary"
                      @change="value => handleSwitchChange('osgb', value)"
                      v-model="dataSets.osgb.enable"
                      active-color="#077ffe"
                      inactive-color="#b7b7b7">
                    </el-switch>
                  </div>
                </template>
                <div class="dataset-config">
                  <div class="count-config">
                    <div class="label searchLabel">数据集数量(个)：</div>
                    <el-input-number
                      class="input-number-primary"
                      controls-position="right"
                      size="mini"
                      @change="value => handleInputChange('osgb', value)"
                      v-model="dataSets.osgb.dataSetLimit"
                      :min="-1" />
                  </div>
                  <div class="common-checkbox-box checkbox-gap">
                    <el-checkbox
                      class="checkbox-primary checkbox-source"
                      v-for="(item, index) in osgbMenu"
                      :key="index"
                      :value="isDataSetMenuChecked('osgb', item)"
                      @change="
                        value => handleDataSetMenuChange('osgb', item, value)
                      "
                      >{{ item.name }}</el-checkbox
                    >
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item name="panorama">
                <template slot="title">
                  <div>
                    <i
                      :class="`collapse__arrow el-icon-arrow-down ${
                        activeTypes.includes('panorama') ? 'is-active' : ''
                      }`"></i>
                    <span class="searchLabel">360全景图</span>
                  </div>
                  <div @click="e => e.stopPropagation()">
                    <span class="searchLabel">是否启用：</span>
                    <el-switch
                      class="switch-primary"
                      @change="value => handleSwitchChange('panorama', value)"
                      v-model="dataSets.panorama.enable"
                      active-color="#077ffe"
                      inactive-color="#b7b7b7">
                    </el-switch>
                  </div>
                </template>
                <div class="dataset-config">
                  <div class="count-config">
                    <div class="label searchLabel">数据集数量(个)：</div>
                    <el-input-number
                      class="input-number-primary"
                      controls-position="right"
                      size="mini"
                      @change="value => handleInputChange('panorama', value)"
                      v-model="dataSets.panorama.dataSetLimit"
                      :min="-1" />
                  </div>
                  <div class="common-checkbox-box checkbox-gap">
                    <el-checkbox
                      class="checkbox-primary checkbox-source"
                      v-for="(item, index) in panoramaMenu"
                      :key="index"
                      :value="isDataSetMenuChecked('panorama', item)"
                      @change="
                        value =>
                          handleDataSetMenuChange('panorama', item, value)
                      "
                      >{{ item.name }}</el-checkbox
                    >
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item name="pointCloud">
                <template slot="title">
                  <div>
                    <i
                      :class="`collapse__arrow el-icon-arrow-down ${
                        activeTypes.includes('pointCloud') ? 'is-active' : ''
                      }`"></i>
                    <span class="searchLabel">点云</span>
                  </div>
                  <div @click="e => e.stopPropagation()">
                    <span class="searchLabel">是否启用：</span>
                    <el-switch
                      class="switch-primary"
                      @change="value => handleSwitchChange('pointCloud', value)"
                      v-model="dataSets.pointCloud.enable"
                      active-color="#077ffe"
                      inactive-color="#b7b7b7">
                    </el-switch>
                  </div>
                </template>
                <div class="dataset-config">
                  <div class="count-config">
                    <div class="label searchLabel">数据集数量(个)：</div>
                    <el-input-number
                      class="input-number-primary"
                      controls-position="right"
                      size="mini"
                      @change="value => handleInputChange('pointCloud', value)"
                      v-model="dataSets.pointCloud.dataSetLimit"
                      :min="-1" />
                  </div>
                  <div class="common-checkbox-box checkbox-gap">
                    <el-checkbox
                      class="checkbox-primary checkbox-source"
                      v-for="(item, index) in pointCloudMenu"
                      :key="index"
                      :value="isDataSetMenuChecked('pointCloud', item)"
                      @change="
                        value =>
                          handleDataSetMenuChange('pointCloud', item, value)
                      "
                      >{{ item.name }}</el-checkbox
                    >
                  </div>
                </div>
                <div class="dataset-config">
                  <div
                    class="label searchLabel"
                    style="margin-left: 37px">
                    数据来源：
                  </div>
                  <el-checkbox
                    class="select-all checkbox-primary"
                    :indeterminate="pointCloudSourceIndeterminate"
                    :value="pointCloudSourceSelectAll"
                    @change="
                      value =>
                        handleSelectAllChange('pointCloud', 'source', value)
                    "
                    >全选</el-checkbox
                  >
                  <div
                    class="checkbox-gap"
                    style="margin-left: 67px">
                    <el-checkbox
                      class="checkbox-primary checkbox-source"
                      v-for="(item, index) in pointCloudSourceList"
                      :key="index"
                      :value="isConfigChecked('pointCloud', 'source', item)"
                      @change="
                        value =>
                          handleDataConfigCheckChange(
                            'pointCloud',
                            'source',
                            item,
                            value
                          )
                      "
                      >{{ item.typeName }}</el-checkbox
                    >
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item name="cad">
                <template slot="title">
                  <div>
                    <i
                      :class="`collapse__arrow el-icon-arrow-down ${
                        activeTypes.includes('cad') ? 'is-active' : ''
                      }`"></i>
                    <span class="searchLabel">二维图纸</span>
                  </div>
                  <div @click="e => e.stopPropagation()">
                    <span class="searchLabel">是否启用：</span>
                    <el-switch
                      class="switch-primary"
                      @change="value => handleSwitchChange('cad', value)"
                      v-model="dataSets.cad.enable"
                      active-color="#077ffe"
                      inactive-color="#b7b7b7">
                    </el-switch>
                  </div>
                </template>
                <div class="dataset-config">
                  <div class="count-config">
                    <div class="label searchLabel">数据集数量(个)：</div>
                    <el-input-number
                      class="input-number-primary"
                      controls-position="right"
                      size="mini"
                      @change="value => handleInputChange('cad', value)"
                      v-model="dataSets.cad.dataSetLimit"
                      :min="-1" />
                  </div>
                  <div class="common-checkbox-box checkbox-gap">
                    <el-checkbox
                      class="checkbox-primary checkbox-source"
                      v-for="(item, index) in cadMenu"
                      :key="index"
                      :value="isDataSetMenuChecked('cad', item)"
                      @change="
                        value => handleDataSetMenuChange('cad', item, value)
                      "
                      >{{ item.name }}</el-checkbox
                    >
                  </div>
                </div>
                <div class="dataset-config">
                  <div
                    class="label searchLabel"
                    style="margin-left: 38px">
                    文件类型：
                  </div>
                  <el-checkbox
                    class="select-all checkbox-primary"
                    :indeterminate="cadExtensionIndeterminate"
                    :value="cadExtensionSelectAll"
                    @change="
                      value => handleSelectAllChange('cad', 'extension', value)
                    "
                    >全选</el-checkbox
                  >
                  <div
                    class="checkbox-gap"
                    style="margin-left: 66px">
                    <el-checkbox
                      class="checkbox-primary checkbox-source"
                      v-for="(item, index) in cadExtensionList"
                      :key="index"
                      :value="isConfigChecked('cad', 'extension', item)"
                      @change="
                        value =>
                          handleDataConfigCheckChange(
                            'cad',
                            'extension',
                            item,
                            value
                          )
                      "
                      >{{ item.extension }}</el-checkbox
                    >
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item name="vector">
                <template slot="title">
                  <div>
                    <i
                      :class="`collapse__arrow el-icon-arrow-down ${
                        activeTypes.includes('vector') ? 'is-active' : ''
                      }`"></i>
                    <span class="searchLabel">矢量数据</span>
                  </div>
                  <div @click="e => e.stopPropagation()">
                    <span class="searchLabel">是否启用：</span>
                    <el-switch
                      class="switch-primary"
                      @change="value => handleSwitchChange('vector', value)"
                      v-model="dataSets.vector.enable"
                      active-color="#077ffe"
                      inactive-color="#b7b7b7">
                    </el-switch>
                  </div>
                </template>
                <div class="dataset-config">
                  <div class="count-config">
                    <div class="label searchLabel">数据集数量(个)：</div>
                    <el-input-number
                      class="input-number-primary"
                      controls-position="right"
                      size="mini"
                      @change="value => handleInputChange('vector', value)"
                      v-model="dataSets.vector.dataSetLimit"
                      :min="-1" />
                  </div>
                  <div class="common-checkbox-box checkbox-gap">
                    <el-checkbox
                      class="checkbox-primary checkbox-source"
                      v-for="(item, index) in vectorMenu"
                      :key="index"
                      :value="isDataSetMenuChecked('vector', item)"
                      @change="
                        value => handleDataSetMenuChange('vector', item, value)
                      "
                      >{{ item.name }}</el-checkbox
                    >
                  </div>
                </div>
                <div class="dataset-config">
                  <div
                    class="label searchLabel"
                    style="margin-left: 38px">
                    文件类型：
                  </div>
                  <el-checkbox
                    class="select-all checkbox-primary"
                    :indeterminate="vectorExtensionIndeterminate"
                    :value="vectorExtensionSelectAll"
                    @change="
                      value =>
                        handleSelectAllChange('vector', 'extension', value)
                    "
                    >全选</el-checkbox
                  >
                  <div
                    class="checkbox-gap"
                    style="margin-left: 66px">
                    <el-checkbox
                      class="checkbox-primary checkbox-source"
                      v-for="(item, index) in vectorExtensionList"
                      :key="index"
                      :value="isConfigChecked('vector', 'extension', item)"
                      @change="
                        value =>
                          handleDataConfigCheckChange(
                            'vector',
                            'extension',
                            item,
                            value
                          )
                      "
                      >{{ item.extension }}</el-checkbox
                    >
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
        <div class="config-item-box">
          <div class="title">
            <div class="icon">
              <img
                src="@/assets/icon/useLimit.png"
                alt="" />
            </div>
            <span class="text searchLabel">场景限制</span>
          </div>
          <div class="content">
            <div class="scene-config">
              <div class="config-item">
                <div class="common-checkbox-box">
                  <el-checkbox
                    class="checkbox-primary"
                    v-for="(item, index) in sceneMenu"
                    :key="index"
                    :value="isSceneMenuChecked(item)"
                    @change="value => handleSceneMenuChange(item, value)"
                    >{{ item.name }}</el-checkbox
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="config-item-box">
          <div class="config-item-title-box">
            <div class="title">
              <div class="icon">
                <img
                  src="@/assets/icon/useLimit.png"
                  alt="" />
              </div>
              <span class="text searchLabel">构件库菜单</span>
            </div>
            <div class="common-switch-box">
              <span class="searchLabel">是否启用：</span>
              <el-switch
                class="switch-primary"
                v-model="componentLibrary.enable">
              </el-switch>
            </div>
          </div>
          <div class="content">
            <div class="single-config">
              <div class="config-item">
                <span class="label searchLabel">公共库文件数量(个)：</span>
                <el-input-number
                  class="input-number-primary"
                  controls-position="right"
                  size="mini"
                  v-model="componentLibrary.publicClFileCountLimit"
                  :min="-1"></el-input-number>
              </div>
              <div class="config-item">
                <span class="label searchLabel">个人库文件数量(个)：</span>
                <el-input-number
                  class="input-number-primary"
                  controls-position="right"
                  size="mini"
                  v-model="componentLibrary.privateClFileCountLimit"
                  :min="-1"></el-input-number>
              </div>
            </div>
          </div>
        </div>
        <div class="config-item-box">
          <div class="config-item-title-box">
            <div class="title">
              <div class="icon">
                <img
                  src="@/assets/icon/useLimit.png"
                  alt="" />
              </div>
              <span class="text searchLabel">数据迁移</span>
            </div>
            <div class="common-switch-box">
              <span class="searchLabel">是否启用：</span>
              <el-switch
                class="switch-primary"
                v-model="exportPublish.enable">
              </el-switch>
            </div>
          </div>
          <div class="content scene-config-content">
            <div class="scene-config">
              <div class="config-item">
                <div class="common-checkbox-box">
                  <el-checkbox
                    class="checkbox-primary"
                    v-for="(item, index) in exportPublishMenu"
                    :key="index"
                    :value="isPublishMenuChecked(item)"
                    @change="value => handlePublishMenuChange(item, value)"
                    >{{ item.name }}</el-checkbox
                  >
                </div>
              </div>
            </div>
            <div class="paltform-type-box">
              <div class="title-box">
                <div class="searchLabel">平台类型</div>
                <div class="common-switch-box">
                  <span class="searchLabel">作为发布平台部署：</span>
                  <el-switch
                    class="switch-primary"
                    v-model="exportPublish.isPublishPlatform" />
                </div>
              </div>
              <div class="content-box">
                <div class="item-box">
                  <div class="label searchLabel">平台ID</div>
                  <div class="common-input-box">
                    <el-input
                      class="input-primary"
                      v-model="exportPublish.platformId"
                      size="mini"
                      :disabled="!exportPublish.isPublishPlatform" />
                  </div>
                </div>
                <div class="item-box">
                  <div class="label searchLabel">平台机器码</div>
                  <div class="common-input-box">
                    <el-input
                      class="input-primary"
                      v-model="exportPublish.platformUuid"
                      :disabled="!exportPublish.isPublishPlatform"
                      size="mini" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="config-item-box">
          <div class="title">
            <div class="icon">
              <img
                src="@/assets/icon/useLimit.png"
                alt="" />
            </div>
            <span class="text searchLabel">授权限制</span>
          </div>
          <div class="content">
            <div class="authorization-config">
              <div class="config-item">
                <span class="label searchLabel">资源发布有效期：</span>
                <div>
                  <el-date-picker
                    class="date-picker-primary"
                    v-model="warranty.resPublicEffectiveDate"
                    type="date"
                    size="mini"
                    popper-class="datepicker-popper-box"
                    :append-to-body="false"
                    placeholder="选择日期" />
                </div>
              </div>
              <div class="config-item">
                <span class="label searchLabel">平台授权地址：</span>
                <div
                  v-for="(item, index) in warranty.platformWebUrls"
                  :key="index">
                  <el-input
                    class="input-primary url-input"
                    @input="value => urlChange('platformWebUrls', index, value)"
                    :value="item"
                    size="mini">
                  </el-input>
                  <i
                    class="el-icon-delete icon"
                    @click="deleteUrl('platformWebUrls', index)"></i>
                </div>
                <i
                  class="el-icon-plus icon"
                  @click="addUrl('platformWebUrls')"></i>
              </div>
              <div class="config-item">
                <span class="label searchLabel">资源授权地址：</span>
                <div
                  v-for="(item, index) in warranty.resPublishUrls"
                  :key="index">
                  <el-input
                    class="input-primary url-input"
                    :value="item"
                    @input="value => urlChange('resPublishUrls', index, value)"
                    size="mini">
                  </el-input>
                  <i
                    class="el-icon-delete icon"
                    @click="deleteUrl('resPublishUrls', index)"></i>
                </div>
                <i
                  class="el-icon-plus icon"
                  @click="addUrl('resPublishUrls')"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="config-item-box">
          <div class="title">
            <div class="icon">
              <img
                src="@/assets/icon/devLimit.png"
                alt="" />
            </div>
            <span class="text searchLabel">开发限制</span>
          </div>
          <div class="content">
            <div class="develop-config">
              <div class="config-item">
                <span class="searchLabel">开放转换接口：</span>
                <el-switch
                  class="switch-primary"
                  v-model="develop.serverAdvancedInterface"
                  active-color="#077ffe"
                  inactive-color="#b7b7b7">
                </el-switch>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="activeTab === '2'"
        class="customer-info-box">
        <el-form
          class="public-form-primary"
          :model="customerForm"
          :rules="rules"
          label-width="100px"
          ref="customerForm">
          <el-form-item
            label="客户单位:"
            prop="companyName">
            <el-input
              class="input-primary"
              v-model="customerForm.companyName"
              placeholder="请输入客户单位名称">
            </el-input>
          </el-form-item>
          <el-form-item
            label="对接人:"
            prop="contact">
            <el-input
              class="input-primary"
              v-model="customerForm.contact"
              placeholder="请输入对接人姓名"></el-input>
          </el-form-item>
          <el-form-item label="职位:">
            <el-input
              class="input-primary"
              v-model="customerForm.contactPosition"
              placeholder="请输入职位"></el-input>
          </el-form-item>
          <el-form-item
            label="手机号:"
            prop="mobile">
            <el-input
              class="input-primary"
              v-model="customerForm.mobile"
              placeholder="请输入客户联系方式"></el-input>
          </el-form-item>
          <el-form-item label="邮箱:">
            <el-input
              class="input-primary"
              v-model="customerForm.email"
              placeholder="请输入邮箱"></el-input>
          </el-form-item>
          <el-form-item label="微信:">
            <el-input
              class="input-primary"
              v-model="customerForm.weChat"
              placeholder="请输入客户微信号">
            </el-input>
          </el-form-item>
          <el-form-item label="备注:">
            <el-input
              class="input-primary"
              type="textarea"
              placeholder="请输入客户信息简介"
              maxlength="200"
              :autosize="{ minRows: 5, maxRows: 8 }"
              show-word-limit
              v-model="customerForm.remarks"></el-input>
          </el-form-item>
        </el-form>
        <div class="operation-btns">
          <el-button
            size="small"
            class="negative-btn normal-btn"
            @click="reset('customerInfo')"
            >重置</el-button
          >
          <el-button
            size="small"
            type="primary"
            class="primary-btn"
            @click="saveCustomer"
            >保存</el-button
          >
        </div>
      </div>
    </div>
    <customer-dialog
      :visible="customerDialogVisible"
      :closeDialog="closeCustomerDialog"
      :queryCustomerList="queryCustomerList" />

    <drag-dialog
      v-if="deleteDialogvisible"
      title="删除客户"
      :width="300"
      :before-close="closeDialog"
      :visible.sync="deleteDialogvisible"
      :footerBtn="['cancel', 'submit']"
      :defaultTop="360"
      :defaultLeft="750"
      :submit="deleteCustomer"
      :cancel="closeDialog">
      <div class="info-tooltip">
        <div>
          <span><i class="el-icon-warning icon"></i></span>
          <span>确定删除当前客户吗？</span>
        </div>
        <div class="extra-box">
          <el-checkbox
            class="checkbox-primary"
            v-model="clearCustomerConfig"
            >同时删除客户的权限设置</el-checkbox
          >
        </div>
      </div>
    </drag-dialog>
  </div>
</template>

<script>
import dragDialog from '@/components/DragDialog.vue'
import customerDialog from '@/components/CustomerDialog.vue'

import {
  getPrivateExistingCustomers,
  getPrivateConfigInfo,
  modifyPrivateCustomer,
  modifyPrivateConfig,
  deletePrivateConfig,
  downloadPrivateConfigFile
} from '@/service/interface'

export default {
  data() {
    return {
      customerDialogVisible: false,
      expandedArrow: true,
      customerList: [],
      selectCustomerInfo: {},
      activeTab: '1',
      configVisible: false,
      customerInfoVisible: false,

      deleteDialogvisible: false,
      clearCustomerConfig: false,

      customerForm: {
        companyName: '',
        contact: '',
        contactPosition: '',
        mobile: '',
        email: '',
        weChat: '',
        remarks: ''
      },

      activeTypes: [
        'bim',
        'rs',
        'wmts',
        'osgb',
        'panorama',
        'pointCloud',
        'cad',
        'vector'
      ],
      bimSourceIndeterminate: false,
      bimSourceSelectAll: false,
      bimExtensionIndeterminate: false,
      bimExtensionSelectAll: false,
      pointCloudSourceIndeterminate: false,
      pointCloudSourceSelectAll: false,
      cadExtensionIndeterminate: false,
      cadExtensionSelectAll: false,
      vectorExtensionIndeterminate: false,
      vectorExtensionSelectAll: false,
      dataSets: {
        bim: {
          enable: false,
          dataSetLimit: 0,
          source: [],
          extension: [],
          menu: {
            upload: {
              name: '上传',
              enable: true
            },
            download: {
              name: '下载',
              enable: true
            },
            delete: {
              name: '删除',
              enable: true
            },
            convert: {
              name: '转换',
              enable: true
            },
            texture: {
              name: '纹理动画',
              enable: true
            },
            renderPriority: {
              name: '渲染优先级',
              enable: true
            }
          }
        },
        rs: {
          enable: false,
          dataSetLimit: 0,
          source: [],
          extension: [],
          menu: {
            upload: {
              name: '上传',
              enable: true
            },
            download: {
              name: '下载',
              enable: true
            },
            delete: {
              name: '删除',
              enable: true
            }
          }
        },
        wmts: {
          enable: false,
          dataSetLimit: 0,
          source: [],
          extension: [],
          menu: {
            add: {
              name: '新增地图',
              enable: true
            },
            edit: {
              name: '编辑',
              enable: true
            },
            delete: {
              name: '删除',
              enable: true
            }
          }
        },
        osgb: {
          enable: false,
          dataSetLimit: 0,
          source: [],
          extension: [],
          menu: {
            upload: {
              name: '上传',
              enable: true
            },
            download: {
              name: '下载',
              enable: true
            },
            delete: {
              name: '删除',
              enable: true
            }
          }
        },
        panorama: {
          enable: false,
          dataSetLimit: 0,
          source: [],
          extension: [],
          menu: {
            upload: {
              name: '上传',
              enable: true
            },
            download: {
              name: '下载',
              enable: true
            },
            delete: {
              name: '删除',
              enable: true
            },
            convert: {
              name: '转换',
              enable: true
            }
          }
        },
        pointCloud: {
          enable: false,
          dataSetLimit: 0,
          source: [],
          extension: [],
          menu: {
            upload: {
              name: '上传',
              enable: true
            },
            download: {
              name: '下载',
              enable: true
            },
            delete: {
              name: '删除',
              enable: true
            },
            convert: {
              name: '转换',
              enable: true
            }
          }
        },
        cad: {
          enable: false,
          dataSetLimit: 0,
          source: [],
          extension: [],
          menu: {
            upload: {
              name: '上传',
              enable: true
            },
            download: {
              name: '下载',
              enable: true
            },
            delete: {
              name: '删除',
              enable: true
            }
          }
        },
        vector: {
          enable: false,
          dataSetLimit: 0,
          source: [],
          extension: [],
          menu: {
            upload: {
              name: '上传',
              enable: true
            },
            download: {
              name: '下载',
              enable: true
            },
            delete: {
              name: '删除',
              enable: true
            },
            convert: {
              name: '转换',
              enable: true
            }
          }
        }
      },
      scene: {
        menu: {
          addComponentLibrary: {
            name: '添加单构件模型',
            enable: false
          },
          publish: {
            name: '发布场景',
            enable: false
          }
        }
      },
      sceneMenu: [
        { name: '添加单构件模型', value: 'addComponentLibrary', enable: false },
        { name: '发布场景', value: 'publish', enable: false }
      ],
      projects: {
        projectCountLimit: 0,
        clusterCountLimit: 0,
        sceneCountLimit: 0,
        totalFileSizeLimit: 0,
        dataSetCountLimit: 0,
        fileCountLimit: 0,
        convertNodesCountLimit: 0,
        resNodesCountLimit: 0,
        fileCountPerProjectLimit: 0,
        dataSetCountPerProjectLimit: 0,
        sceneCountPerProjectLimit: 0
      },
      componentLibrary: {
        enable: false,
        publicClFileCountLimit: 0,
        privateClFileCountLimit: 0
      },
      warranty: {
        resPublicEffectiveDate: '',
        platformWebUrls: [],
        resPublishUrls: [],
        globalFileUploadSizeLimit: 0
      },
      develop: {
        serverAdvancedInterface: false
      },
      exportPublish: {
        enable: false,
        isPublishPlatform: false,
        menu: {
          exportPage: {
            name: '导出页面',
            enable: false
          },
          importPage: {
            name: '导入页面',
            enable: false
          }
        },
        platformId: '',
        platformUuid: ''
      },
      exportPublishMenu: [
        { name: '导出页面', value: 'exportPage', enable: false },
        { name: '导入页面', value: 'importPage', enable: false }
      ],
      bimMenu: [
        { name: '上传', value: 'upload', enable: false },
        { name: '下载', value: 'download', enable: false },
        { name: '删除', value: 'delete', enable: false },
        { name: '转换', value: 'convert', enable: false },
        { name: '纹理动画', value: 'texture', enable: false },
        { name: '渲染优先级', value: 'renderPriority', enable: false }
      ],
      bimSourceList: [
        { typeName: 'revit', value: false },
        { typeName: 'navisworks', value: false },
        { typeName: '3dsmax', value: false },
        { typeName: 'rhino', value: false },
        { typeName: 'dgn', value: false },
        { typeName: 'bimplugin', value: false },
        { typeName: 'online', value: false }
      ],
      bimExtensionList: [
        { extension: '.rvt', value: false },
        { extension: '.pak', value: false },
        { extension: '.3dxml', value: false },
        { extension: '.gim', value: false },
        { extension: '.ifc', value: false },
        { extension: '.igms', value: false },
        { extension: '.fbx', value: false },
        { extension: '.gltf', value: false },
        { extension: '.stp', value: false },
        { extension: '.3dm', value: false },
        { extension: '.skp', value: false },
        { extension: '.glb', value: false },
        { extension: '.dgn', value: false },
        { extension: '.nwd', value: false },
        { extension: '.nwc', value: false },
        { extension: '.rvm', value: false },
        { extension: '.obj', value: false },
        { extension: '.obj.zip', value: false },
        { extension: '.stl', value: false },
        { extension: '.cdm', value: false }
      ],
      rsMenu: [
        { name: '上传', value: 'upload', enable: false },
        { name: '下载', value: 'download', enable: false },
        { name: '删除', value: 'delete', enable: false }
      ],
      wmtsMenu: [
        { name: '新增地图', value: 'add', enable: false },
        { name: '编辑', value: 'edit', enable: false },
        { name: '删除', value: 'delete', enable: false }
      ],
      osgbMenu: [
        { name: '上传', value: 'upload', enable: false },
        { name: '下载', value: 'download', enable: false },
        { name: '删除', value: 'delete', enable: false }
      ],
      panoramaMenu: [
        { name: '上传', value: 'upload', enable: false },
        { name: '下载', value: 'download', enable: false },
        { name: '删除', value: 'delete', enable: false },
        { name: '转换', value: 'convert', enable: false }
      ],
      pointCloudSourceList: [
        { typeName: '.asc', value: false },
        { typeName: '.pts', value: false },
        { typeName: '.las', value: false },
        { typeName: '.e57', value: false },
        { typeName: '.pcd', value: false },
        { typeName: '.ply', value: false }
      ],
      pointCloudMenu: [
        { name: '上传', value: 'upload', enable: false },
        { name: '下载', value: 'download', enable: false },
        { name: '删除', value: 'delete', enable: false },
        { name: '转换', value: 'convert', enable: false }
      ],
      cadExtensionList: [
        { extension: '.dwg', value: false },
        { extension: '.dxf', value: false },
        { extension: '.pdf', value: false }
      ],
      cadMenu: [
        { name: '上传', value: 'upload', enable: false },
        { name: '下载', value: 'download', enable: false },
        { name: '删除', value: 'delete', enable: false }
      ],
      vectorExtensionList: [
        { extension: '.shp.zip', value: false },
        { extension: '.kml', value: false },
        { extension: '.kmz', value: false }
      ],
      vectorMenu: [
        { name: '上传', value: 'upload', enable: false },
        { name: '下载', value: 'download', enable: false },
        { name: '删除', value: 'delete', enable: false },
        { name: '删除', value: 'convert', enable: false }
      ],

      rules: {
        companyName: [
          {
            required: true,
            message: '请输入客户单位名称',
            trigger: 'blur'
          }
        ],
        contact: [
          {
            required: true,
            message: '请输入对接人',
            trigger: 'blur'
          }
        ],
        mobile: [
          {
            required: true,
            message: '请输入手机号',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  components: { dragDialog, customerDialog },
  created() {
    this.queryCustomerList()
  },
  methods: {
    queryCustomerList(customerId) {
      return new Promise(resolve => {
        getPrivateExistingCustomers().then(response => {
          if (response.isSuccess) {
            let data = response.data
            this.customerList = data.customers
            let find = this.customerList.find(el => el.id === customerId)
            if (find) {
              this.onUserClick(find)
            } else {
              this.onUserClick(this.customerList[0])
            }
            resolve()
          }
        })
      })
    },
    onUserClick(customerInfo) {
      if (!customerInfo) {
        this.configVisible = false
        this.customerInfoVisible = false
        return
      }

      this.resetAllConfig()
      this.clearCustomForm()
      getPrivateConfigInfo(customerInfo.id).then(response => {
        if (response.isSuccess) {
          let data = response.data
          this.customerForm = {
            companyName: data.companyName,
            contact: data.contact,
            contactPosition: data.contactPosition,
            mobile: data.mobile,
            email: data.email,
            weChat: data.weChat,
            remarks: data.remarks
          }
          if (data.initializeDeploy) {
            this.dataSets = data.initializeDeploy.dataSets
            this.scene = data.initializeDeploy.scene
            this.projects = data.initializeDeploy.projects
            this.componentLibrary = data.initializeDeploy.componentLibrary
            this.warranty = data.initializeDeploy.warranty
            this.develop = data.initializeDeploy.develop
            this.exportPublish = data.initializeDeploy.exportPublish
          }
          this.selectCustomerInfo = {
            id: customerInfo.id,
            config: data.initializeDeploy ? data.initializeDeploy : {}
          }
          this.configVisible = true
        }
      })
    },
    openCreateDialog() {
      this.customerDialogVisible = true
    },
    closeCustomerDialog() {
      this.customerDialogVisible = false
    },
    openDeleteDialog() {
      this.deleteDialogvisible = true
    },
    deleteCustomer() {
      let params = { id: this.selectCustomerInfo.id }
      deletePrivateConfig(params).then(response => {
        if (response.isSuccess) {
          this.queryCustomerList().then(() => {
            this.$message.success('删除成功！！！')
            this.closeDialog()
          })
        }
      })
    },
    closeDialog() {
      this.deleteDialogvisible = false
    },

    tabsClick(key) {
      const tabName = key.name
      if (tabName === '1') {
        this.openConfig()
      } else {
        this.openCustomerInfo()
      }
    },
    openConfig() {
      this.configVisible = true
      this.customerInfoVisible = false
    },
    downloadLicense() {
      if (!this.selectCustomerInfo.id) return
      downloadPrivateConfigFile(this.selectCustomerInfo.id, {
        responseType: 'blob'
      }).then(response => {
        let blob = new Blob([response], {
          type: '*'
        })
        let url = window.URL.createObjectURL(blob)
        let a = document.createElement('a')
        a.href = url
        a.download = 'license.txt'
        a.click()

        window.URL.revokeObjectURL(url)
      })
    },
    openCustomerInfo() {
      this.configVisible = false
      this.customerInfoVisible = true
    },
    handleSwitchChange(dataType, value) {
      let dataInfo = this.dataSets[dataType]
      if (!value) {
        dataInfo.dataSetLimit = 0
      }
    },
    handleInputChange(dataType, value) {
      let dataInfo = this.dataSets[dataType]
      if (value > 0) {
        dataInfo.enable = true
      }
    },
    handleSelectAllChange(dataType, field, value) {
      let dataInfo = this.dataSets[dataType]
      let fieldValue = dataInfo[field]
      if (value) {
        dataInfo.enable = true
        if (field === 'source') {
          if (dataType === 'bim') {
            this.bimSourceList.forEach(item => {
              item.value = true
              let find = fieldValue.find(el => el.typeName === item.typeName)
              if (!find) {
                fieldValue.push(item)
              } else {
                find.value = true
              }
            })
          }
          if (dataType === 'pointCloud') {
            this.pointCloudSourceList.forEach(item => {
              item.value = true
              let find = fieldValue.find(el => el.typeName === item.typeName)
              if (!find) {
                fieldValue.push(item)
              } else {
                find.value = true
              }
            })
          }
        } else {
          if (dataType === 'bim') {
            this.bimExtensionList.forEach(item => {
              item.value = true
              let find = fieldValue.find(el => el.extension === item.extension)
              if (!find) {
                fieldValue.push(item)
              } else {
                find.value = true
              }
            })
          }
          if (dataType === 'cad') {
            this.cadExtensionList.forEach(item => {
              item.value = true
              let find = fieldValue.find(el => el.extension === item.extension)
              if (!find) {
                fieldValue.push(item)
              } else {
                find.value = true
              }
            })
          }
          if (dataType === 'vector') {
            this.vectorExtensionList.forEach(item => {
              item.value = true
              let find = fieldValue.find(el => el.extension === item.extension)
              if (!find) {
                fieldValue.push(item)
              } else {
                find.value = true
              }
            })
          }
        }
      } else {
        dataInfo[field] = []
      }
    },
    handleDatatypeCheckChange(dataType, field, value) {
      let data = this.dataSets[dataType]
      data[field] = value
    },
    handleDataConfigCheckChange(dataType, field, dataConfig, value) {
      this.$delete(dataConfig, 'value')
      this.$set(dataConfig, 'value', value)

      let data = this.dataSets[dataType]
      let fieldValue = data[field]
      let find = null
      if (field === 'source') {
        find = fieldValue.find(el => el.typeName === dataConfig.typeName)
      } else {
        find = fieldValue.find(el => el.extension === dataConfig.extension)
      }
      if (!find) {
        fieldValue.push(dataConfig)
      } else {
        find.value = value
      }

      let enable = fieldValue.some(el => el.value)
      if (enable) {
        this.dataSets[dataType].enable = enable
      }
    },
    isConfigChecked(dataType, field, dataConfig) {
      const extensionFilter = ['.gmc', '.gbp', '.zip', '.iam', '.ipt']

      let dataInfo = this.dataSets[dataType]
      if (!dataInfo.enable) {
        if (field === 'source') {
          if (dataType === 'bim') {
            this.bimSourceIndeterminate = false
            this.bimSourceSelectAll = false
          }
          if (dataType === 'pointCloud') {
            this.pointCloudSourceIndeterminate = false
            this.pointCloudSourceSelectAll = false
          }
        } else {
          if (dataType === 'bim') {
            this.bimExtensionIndeterminate = false
            this.bimExtensionSelectAll = false
          }
          if (dataType === 'cad') {
            this.cadExtensionIndeterminate = false
            this.cadExtensionSelectAll = false
          }
          if (dataType === 'vector') {
            this.vectorExtensionIndeterminate = false
            this.vectorExtensionSelectAll = false
          }
        }

        dataInfo[field] = []
        return false
      }

      let fieldValue = dataInfo[field]
      fieldValue = fieldValue.filter(
        el => !extensionFilter.includes(el.extension)
      )
      let checkedArray = fieldValue.filter(el => el.value)
      let find = null
      if (field === 'source') {
        if (dataType === 'bim') {
          if (!checkedArray.length) {
            this.bimSourceIndeterminate = false
            this.bimSourceSelectAll = false
          } else {
            if (checkedArray.length === this.bimSourceList.length) {
              this.bimSourceIndeterminate = false
              this.bimSourceSelectAll = true
            }
            if (checkedArray.length < this.bimSourceList.length) {
              this.bimSourceIndeterminate = true
              this.bimSourceSelectAll = false
            }
          }
        }
        if (dataType === 'pointCloud') {
          if (!checkedArray.length) {
            this.pointCloudSourceIndeterminate = false
            this.pointCloudSourceSelectAll = false
          } else {
            if (checkedArray.length === this.pointCloudSourceList.length) {
              this.pointCloudSourceIndeterminate = false
              this.pointCloudSourceSelectAll = true
            }
            if (checkedArray.length < this.pointCloudSourceList.length) {
              this.pointCloudSourceIndeterminate = true
              this.pointCloudSourceSelectAll = false
            }
          }
        }
        find = fieldValue.find(el => el.typeName === dataConfig.typeName)
      } else {
        if (dataType === 'bim') {
          if (!checkedArray.length) {
            this.bimExtensionIndeterminate = false
            this.bimExtensionSelectAll = false
          } else {
            if (checkedArray.length === this.bimExtensionList.length) {
              this.bimExtensionIndeterminate = false
              this.bimExtensionSelectAll = true
            }
            if (checkedArray.length < this.bimExtensionList.length) {
              this.bimExtensionIndeterminate = true
              this.bimExtensionSelectAll = false
            }
          }
        }
        if (dataType === 'cad') {
          if (!checkedArray.length) {
            this.cadExtensionIndeterminate = false
            this.cadExtensionSelectAll = false
          } else {
            if (checkedArray.length === this.cadExtensionList.length) {
              this.cadExtensionIndeterminate = false
              this.cadExtensionSelectAll = true
            }
            if (checkedArray.length < this.cadExtensionList.length) {
              this.cadExtensionIndeterminate = true
              this.cadExtensionSelectAll = false
            }
          }
        }
        if (dataType === 'vector') {
          if (!checkedArray.length) {
            this.vectorExtensionIndeterminate = false
            this.vectorExtensionSelectAll = false
          } else {
            if (checkedArray.length === this.vectorExtensionList.length) {
              this.vectorExtensionIndeterminate = false
              this.vectorExtensionSelectAll = true
            }
            if (checkedArray.length < this.vectorExtensionList.length) {
              this.vectorExtensionIndeterminate = true
              this.vectorExtensionSelectAll = false
            }
          }
        }
        find = fieldValue.find(el => el.extension === dataConfig.extension)
      }
      if (find) {
        return find.value
      } else {
        return false
      }
    },
    isDataSetMenuChecked(dataType, dataConfig) {
      let dataInfo = this.dataSets[dataType]
      let menuConfig = dataInfo.menu
      let obj = menuConfig[dataConfig.value]
      return obj.enable
    },
    handleDataSetMenuChange(dataType, dataConfig, value) {
      this.$delete(dataConfig, 'enable')
      this.$set(dataConfig, 'enable', value)

      let dataInfo = this.dataSets[dataType]
      let menuConfig = dataInfo.menu
      let obj = menuConfig[dataConfig.value]
      obj.enable = value
    },
    isSceneMenuChecked(dataConfig) {
      let menuConfig = this.scene.menu
      let obj = menuConfig[dataConfig.value]
      return obj.enable
    },
    handleSceneMenuChange(dataConfig, value) {
      this.$delete(dataConfig, 'enable')
      this.$set(dataConfig, 'enable', value)

      let menuConfig = this.scene.menu
      let obj = menuConfig[dataConfig.value]
      obj.enable = value
    },
    isPublishMenuChecked(dataConfig) {
      let menuConfig = this.exportPublish.menu
      let obj = menuConfig[dataConfig.value]
      return obj.enable
    },
    handlePublishMenuChange(dataConfig, value) {
      this.$delete(dataConfig, 'enable')
      this.$set(dataConfig, 'enable', value)

      let menuConfig = this.exportPublish.menu
      let obj = menuConfig[dataConfig.value]
      obj.enable = value
    },
    addUrl(urlType) {
      this.warranty[urlType].push('')
    },
    deleteUrl(urlType, index) {
      this.warranty[urlType].splice(index, 1)
    },
    urlChange(urlType, index, value) {
      this.$set(this.warranty[urlType], index, value)
    },
    reset(resetType) {
      let customerInfo = this.selectCustomerInfo
      getPrivateConfigInfo(customerInfo.id).then(response => {
        if (response.isSuccess) {
          let data = response.data
          if (resetType === 'customerInfo') {
            this.customerForm = {
              companyName: data.companyName,
              contact: data.contact,
              contactPosition: data.contactPosition,
              mobile: data.mobile,
              email: data.email,
              weChat: data.weChat,
              remarks: data.remarks
            }
          } else {
            this.dataSets = data.initializeDeploy.dataSets
            this.projects = data.initializeDeploy.projects
            this.componentLibrary = data.initializeDeploy.componentLibrary
            this.warranty = data.initializeDeploy.warranty
            this.develop = data.initializeDeploy.develop
            this.exportPublish = data.initializeDeploy.exportPublish
          }
        }
      })
    },
    saveConfig() {
      if (!this.warranty.resPublicEffectiveDate) {
        this.$message.error('资源发布有效期不能为空！！！')
        return
      }

      let customerInfo = this.selectCustomerInfo
      customerInfo.config['dataSets'] = this.dataSets
      customerInfo.config['scene'] = this.scene
      customerInfo.config['projects'] = this.projects
      customerInfo.config['componentLibrary'] = this.componentLibrary
      if (
        this.warranty.resPublicEffectiveDate &&
        this.warranty.resPublicEffectiveDate.toJSON
      ) {
        this.warranty.resPublicEffectiveDate =
          this.warranty.resPublicEffectiveDate.toJSON()
      }
      customerInfo.config['warranty'] = this.warranty
      customerInfo.config['develop'] = this.develop
      customerInfo.config['exportPublish'] = this.exportPublish
      modifyPrivateConfig(customerInfo).then(response => {
        if (response.isSuccess) {
          this.$message.success('更新配置成功！！！')
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    saveCustomer() {
      let params = JSON.parse(JSON.stringify(this.customerForm))
      params['id'] = this.selectCustomerInfo.id
      modifyPrivateCustomer(params).then(response => {
        if (response.isSuccess) {
          this.$message.success('修改客户信息成功')
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    resetAllConfig() {
      this.bimSourceIndeterminate = false
      this.bimSourceSelectAll = false
      this.bimExtensionIndeterminate = false
      this.bimExtensionSelectAll = false
      this.pointCloudSourceIndeterminate = false
      this.pointCloudSourceSelectAll = false
      this.cadExtensionIndeterminate = false
      this.cadExtensionSelectAll = false
      this.vectorExtensionIndeterminate = false
      this.vectorExtensionSelectAll = false
      this.dataSets = {
        bim: {
          enable: false,
          dataSetLimit: 0,
          source: [],
          extension: [],
          menu: {
            upload: {
              name: '上传',
              enable: true
            },
            download: {
              name: '下载',
              enable: true
            },
            delete: {
              name: '删除',
              enable: true
            },
            convert: {
              name: '转换',
              enable: true
            },
            texture: {
              name: '纹理动画',
              enable: true
            },
            renderPriority: {
              name: '渲染优先级',
              enable: true
            }
          }
        },
        rs: {
          enable: false,
          dataSetLimit: 0,
          source: [],
          extension: [],
          menu: {
            upload: {
              name: '上传',
              enable: true
            },
            download: {
              name: '下载',
              enable: true
            },
            delete: {
              name: '删除',
              enable: true
            }
          }
        },
        wmts: {
          enable: false,
          dataSetLimit: 0,
          source: [],
          extension: [],
          menu: {
            add: {
              name: '新增地图',
              enable: true
            },
            edit: {
              name: '编辑',
              enable: true
            },
            delete: {
              name: '删除',
              enable: true
            }
          }
        },
        osgb: {
          enable: false,
          dataSetLimit: 0,
          source: [],
          extension: [],
          menu: {
            upload: {
              name: '上传',
              enable: true
            },
            download: {
              name: '下载',
              enable: true
            },
            delete: {
              name: '删除',
              enable: true
            }
          }
        },
        panorama: {
          enable: false,
          dataSetLimit: 0,
          source: [],
          extension: [],
          menu: {
            upload: {
              name: '上传',
              enable: true
            },
            download: {
              name: '下载',
              enable: true
            },
            delete: {
              name: '删除',
              enable: true
            },
            convert: {
              name: '转换',
              enable: true
            }
          }
        },
        pointCloud: {
          enable: false,
          dataSetLimit: 0,
          source: [],
          extension: [],
          menu: {
            upload: {
              name: '上传',
              enable: true
            },
            download: {
              name: '下载',
              enable: true
            },
            delete: {
              name: '删除',
              enable: true
            },
            convert: {
              name: '转换',
              enable: true
            }
          }
        },
        cad: {
          enable: false,
          dataSetLimit: 0,
          source: [],
          extension: [],
          menu: {
            upload: {
              name: '上传',
              enable: true
            },
            download: {
              name: '下载',
              enable: true
            },
            delete: {
              name: '删除',
              enable: true
            }
          }
        },
        vector: {
          enable: false,
          dataSetLimit: 0,
          source: [],
          extension: [],
          menu: {
            upload: {
              name: '上传',
              enable: true
            },
            download: {
              name: '下载',
              enable: true
            },
            delete: {
              name: '删除',
              enable: true
            },
            convert: {
              name: '转换',
              enable: true
            }
          }
        }
      }
      this.scene = {
        menu: {
          addComponentLibrary: {
            name: '添加单构件模型',
            enable: false
          },
          publish: {
            name: '发布场景',
            enable: false
          }
        }
      }
      this.projects = {
        projectCountLimit: 0,
        clusterCountLimit: 0,
        sceneCountLimit: 0,
        dataSetCountLimit: 0,
        fileCountLimit: 0,
        totalFileSizeLimit: 0,
        convertNodesCountLimit: 0,
        resNodesCountLimit: 0,
        fileCountPerProjectLimit: 0,
        dataSetCountPerProjectLimit: 0,
        sceneCountPerProjectLimit: 0
      }
      this.componentLibrary = {
        enable: false,
        publicClFileCountLimit: 0,
        privateClFileCountLimit: 0
      }
      this.warranty = {
        resPublicEffectiveDate: '',
        globalFileUploadSizeLimit: 0,
        platformWebUrls: [],
        resPublishUrls: []
      }
      this.develop = {
        serverPrimaryInterface: false,
        serverAdvancedInterface: false
      }
      this.exportPublish = {
        enable: false,
        isPublishPlatform: false,
        menu: {
          exportPage: {
            name: '导出页面',
            enable: false
          },
          importPage: {
            name: '导入页面',
            enable: false
          }
        },
        platformId: '',
        platformUuid: ''
      }
    },
    clearCustomForm() {
      this.customerForm = {
        companyName: '',
        contact: '',
        contactPosition: '',
        mobile: '',
        email: '',
        weChat: '',
        remarks: ''
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
@import '@/assets/css/pageStyle.less';
.private-config-container {
  display: flex;
  justify-content: space-between;
  height: 100%;
  font-size: 14px;
  text-align: left;

  .searchLabel {
    white-space: nowrap;
    color: var(--table-text-color);
  }

  .info-tooltip {
    .icon {
      font-size: 20px;
      color: var(--base-light-color20);
      text-align: center;
      vertical-align: middle;
      margin-right: 5px;
    }

    .extra-box {
      margin-top: 5px;
      margin-left: 25px;
    }
  }

  .customer-list-box-tree {
    width: 260px;
    padding: 16px;
    height: 100%;

    .title {
      color: var(--page-title-color);
    }
  }

  .customer-list-box {
    border-radius: 16px;
    margin-right: 16px;
    background: var(--aside-page-bgColor);
    transition: all 0.3s;
    position: relative;
    &:hover {
      .expaned {
        display: block;
      }
    }

    p {
      height: 20px;
      line-height: 10px;
      margin: 5px 0px;
      padding: 4px 10px;
      border-left: 4px solid var(--base-primary-color);
    }

    .primary-btn {
      width: 100%;
      margin-top: 4px;

      .el-icon-plus {
        margin-right: 4px;
      }

      :deep(span) {
        display: inline-block;
      }
    }

    .list-box {
      margin-top: 10px;
      max-height: calc(100% - 60px);
      overflow-y: auto;

      li {
        padding-left: 20px;
        height: 32px;
        line-height: 32px;
        cursor: pointer;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 400;
        color: var(--tree-node-text-color);
        &:not(:last-child) {
          margin-bottom: 4px;
        }
        &:hover {
          background: var(--tree-item-hover-color);
        }
      }

      .active {
        color: var(--base-primary-color);
        background: var(--base-bg-light-color24);
      }
    }
  }

  .customer-box {
    width: calc(100% - 260px);
    overflow: auto;
    padding: 16px;
    padding-top: 8px;
    transition: all 0.3s;

    .justify-flex {
      :deep(.tab-page-primary) {
        .el-tabs__item {
          height: 32px;
          line-height: 32px;
        }
      }
    }

    .opera-cell {
      display: flex;
      justify-content: flex-start;
      margin-bottom: 16px;
      .import-tips {
        display: flex;
        align-items: center;
        margin-left: 20px;
      }
    }

    .create-customer-box {
      position: relative;
      height: calc(100% - 60px);
      text-align: center;
      .icon-box {
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -100px;
        margin-left: -100px;
        border: 1px dashed var(--base-border-dark-color2);
        border-radius: 6px;
        cursor: pointer;
        width: 200px;
        height: 200px;

        .icon {
          font-size: 32px;
          color: var(--default-color);
          line-height: 200px;
          text-align: center;
        }
      }
    }

    .customer-config-box {
      // padding: 0px 10px;

      .config-item-box {
        margin: 8px 0;
        border-radius: 5px;
        background: var(--sassConfig-item-form-bgColor);
        box-shadow: var(--base-bg-dark-color32);
        border-radius: 16px;
        border: 1px solid var(--sassConfig-item-form-border-color);

        .checkbox-gap {
          display: flex;
          flex-wrap: wrap;
          column-gap: 76px;

          .dataSet-menu {
            width: 96px;
          }
          :deep(.el-checkbox) {
            margin-right: 0;
          }
        }

        .config-item-title-box {
          display: flex;
          justify-content: space-between;
          padding: 0px 5px;

          .common-switch-box {
            font-size: 13px;
            line-height: 30px;
            margin-right: 30px;
          }
        }

        .title {
          display: flex;
          padding: 0px 8px;
          padding-top: 8px;
          .icon {
            width: 22px;
            height: 22px;
            line-height: 22px;
            border: 1px solid var(--base-primary-color);
            border-radius: 50%;
            text-align: center;
            margin-right: 8px;
          }
        }

        .scene-config-content {
          margin-left: 8px;
        }
        .content {
          padding-left: 38px;
          .single-config {
            display: flex;
            margin: 8px 0;
            padding-left: 2px;

            .config-item {
              display: flex;
              margin-right: 20px;

              .label {
                line-height: 28px;
                text-align: right;
              }

              .icon {
                color: var(--sassConfig-item-form-icon-color);
              }
            }
          }

          .dataset-config {
            display: flex;
            margin: 5px 0px;
            padding-left: 20px;

            .label {
              width: 100px;
              line-height: 24px;
              color: var(--default-color);
              text-align: right;
            }

            .select-all {
              width: 100px;
              margin-right: 20px;
            }
          }

          .dataset-config-dataSetCount {
          }

          .scene-config {
            display: flex;
            margin: 8px 0;

            .config-item {
              display: flex;
              margin-right: 20px;

              .common-checkbox-box {
                label {
                  margin-right: 60px;
                }
              }
            }
          }

          .publish-config {
            display: flex;
            margin: 5px 20px;

            .config-item {
              display: flex;
              margin-right: 20px;

              .common-checkbox-box {
                label {
                  margin-right: 60px;
                }
              }
            }
          }

          .paltform-type-box {
            margin-bottom: 8px;
            .title-box {
              display: flex;
              justify-content: flex-start;
              font-size: 14px;
              margin-bottom: 6px;
            }

            .content-box {
              display: flex;
              font-size: 14px;
              line-height: 32px;

              .item-box {
                display: flex;
                margin-right: 10px;

                .label {
                  &:before {
                    content: '*';
                    color: var(--error-status-color);
                    margin-right: 4px;
                  }

                  &:after {
                    content: '\ff1a';
                  }
                }
              }
            }
          }

          .project-config {
            display: flex;
            margin: 8px 0;

            .config-item {
              display: flex;
              margin-right: 20px;

              .label {
                line-height: 28px;
                text-align: right;
              }
            }
          }

          .globalLimit {
            .config-item {
              margin-right: 56px;
              .searchLabel {
              }
            }
          }

          .authorization-config {
            margin: 8px 0;

            .config-item {
              display: flex;
              margin-top: 8px;
              .url-input {
                margin-right: 10px;
                width: 180px;
              }

              .icon {
                margin-right: 20px;
                color: var(--base-dark16-color);
                cursor: pointer;
              }

              i {
                line-height: 28px;
                cursor: pointer;
              }
            }
          }

          .develop-config {
            display: flex;
            margin: 8px 0;

            .config-item {
              margin-right: 20px;
            }
          }

          .first-checkbox {
            width: 70px;
          }
        }

        .common-bussiness-collapse-box {
          padding: 8px;

          :deep(.el-collapse-item) {
            border: 1px solid var(--sassConfig-item-form-children-border-color);
            border-radius: 8px;
            .el-collapse-item__header {
              height: 32px;
              display: flex;
              align-items: center;
              background-color: var(--base-bg-dark-color33);
              padding: 0 8px;

              .collapse__arrow {
                color: var(--sassConfig-item-form-icon-color);
              }
            }
            .el-collapse-item__content {
              padding: 8px 30px;
            }
          }

          .dataset-config {
            display: flex;
            margin: 5px 0px;

            :deep(.el-checkbox) {
              .el-checkbox__label {
                color: var(--table-text-color) !important;
              }
            }
            .count-config {
              display: flex;

              // :deep(.el-input-number) {
              //   height: 26px;
              // }
            }

            .common-checkbox-box {
              margin-left: 56px;
            }

            .label {
              // color: var(--default-color);
              text-align: right;
            }

            .select-all {
              width: 100px;
              margin-right: 20px;
            }

            .checkbox-source {
              width: 96px;
            }
          }
        }
      }
    }

    .customer-info-box {
      width: 60%;
      height: calc(100% - 88px);
      display: flex;
      flex-direction: column;

      .public-form-primary {
        flex: 1;
      }

      .operation-btns {
        display: flex;
        justify-content: flex-end;
      }

      :deep(.el-form-item) {
        margin-bottom: 16px;
        .el-input__inner {
          height: 32px;
        }

        .el-form-item__error {
          padding-top: 0 !important;
        }

        &.is-required {
          margin-bottom: 20px;
        }
      }
    }
  }
}

.expaned {
  width: 24px;
  height: 40px;
  border-radius: 16px;
  background-color: var(--aside-arrow-bgColor);
  box-shadow: var(--base-bg-dark-color30);
  border: 1px solid var(--aside-arrow-bgColor);
  position: absolute;
  top: 50%;
  left: 246px;
  transform: translateY(-50%);
  display: none;
  line-height: 40px;
  cursor: pointer;
  &:hover {
    background-color: var(--aside-arrow-hover-bgColor);
    box-shadow: var(--base-bg-dark-color30);
    border-color: transparent;
    border-radius: 16px;
  }

  .el-icon {
    font-weight: 600;
    color: var(--aside-arrow-expand-icon-color);
    margin-left: 50%;
    transform: translateX(-50%);
  }
}
.openTree {
  width: 0 !important;
  padding: 0 !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  border: none;

  .expaned {
    left: -12px !important;
    z-index: 9;
    display: block !important;
  }
}
</style>
